import React, { Component } from 'react';
import myVideo from "./smoke.mp4";
import instructionDesign from "../styles/instruction-style.module.css";
import Tabs from "../components/Tabs";
import "../styles/App.css";
import { Link } from "gatsby"
import ciggy from "../images/ciggy.jpg"
import Popup from 'reactjs-popup';
import { BsJustify, BsChevronRight } from "react-icons/bs";

function WelcomeVideo() {
    return (
        <section className = {instructionDesign.pageSection}>
            <video controls = {false} autoPlay muted>
                <source src = {myVideo} type="video/mp4"></source>
            </video>

            <h1 className = {instructionDesign.textBox}>
                <span className = {instructionDesign.textSpacing}> Welcome </span>
                <span className = {instructionDesign.textSpacing}> to </span>
                <span className = {instructionDesign.textSpacing}> the </span>
                <span className = {instructionDesign.textSpacing}> instructions </span>
                <span className = {instructionDesign.textSpacing}> page </span>
                <span className = {instructionDesign.textSpacing}> 
                    <marquee behavior="scroll" direction="right" scrollamount = "25">
                        <img src={ciggy} alt="Logo" className={instructionDesign.photo}/>Click to Continue
                    </marquee> 
                </span>
            </h1>

        <Popup trigger={
            <div>
                <BsJustify className={instructionDesign.menuIcon}></BsJustify>
            </div>}
            modal
            nested
        >
        {close => (
            <div className={instructionDesign.popupWrapper}>
                <button className={instructionDesign.close} onClick={close}>&times; {/*&times = x symbol*/}</button>   
                <Link to="/">
                    <div className={instructionDesign.mainOption}>
                        Home
                    </div>
                </Link>
                
                <a target="_blank" href="/resourcesNB/">
                    <div className={instructionDesign.mainOption}>
                        Learn More
                    </div>
                </a>
                </div>
            )}
        </Popup>

        </section>
    )
}

function App() {
    return (
      <div className = {instructionDesign.mainInstructions}>
        <Popup trigger={
            <div>
                <BsJustify className={instructionDesign.menuIcon}></BsJustify>
            </div>}
            modal
            nested
        >
        {close => (
            <div className={instructionDesign.popupWrapper}>
                <button className={instructionDesign.close} onClick={close}>&times; {/*&times = x symbol*/}</button>   
                
                <Link to="/">
                    <div className={instructionDesign.mainOption}>
                        Home
                    </div>
                </Link>
                
                <Link to="https://bacr.org/api-chat">
                    <div className={instructionDesign.mainOption}>
                        Learn More
                    </div>
                </Link>
                </div>
            )}
        </Popup>
       <Tabs> 
         <div label="How to Play">
            <p>
                Once you start the game, you will start your role as the newly hired CEO of a tobacco company. Your goal
                is to bring up your market share to 70% in 40 days, or else you will be fired. 
                The game functions on a day-by-day basis. As the head of your company, you will need to 
                handle daily affairs over in your company’s headquarters, the Supreme Court, and your 
                factories. Once you deal with all three of them, you can move onto the next day. Here are more 
                specifics about each category.
            </p> 
            <p>
                As you play through the game, you will notice that a lot of your actions would be highly unethical
                in the real world. These are things that tobacco companies do on a day-to-day basis, and as you play the game,
                you will learn more about these harmful tactics and the harm they result in.
            </p>
         </div> 
         
         <div label="Headquarters"> 
            <p>
                This is where you can make executive actions for your company in order to improve your public 
                image. Be aware that each action has its own associated cost, risk, and market share value! Every time you take an action,
                it will be less effective the next time you preform that same action. For example, if you decide to Increase Production one day,
                the next time you decide to Increase Production, it will not be as effective!
            </p>
            <p>
                You can also find the lobbying section here, where you may donate money to lobbyists for either 
                the Senate and/or House of Representatives to sway them to support legislation that is favorable
                to you and your business.
            </p>
         </div> 

         <div label="Supreme Court"> 
            <p>
                Your company will have to deal with court cases through which people will try to take down your 
                corporation. It’s your job to hire an appropriate lawyer so that you do not lose the case! If you 
                are found guilty, then the company is sued and loses money. If you win, no action is taken 
                against your company (but you will still have to pay the lawyer fee).
            </p> 
            <p>
                Please note, the cases used are examples of real-life court cases. The people bringing these 
                lawsuits against your company are real-people, who have been affected negativley by your products.
            </p>
         </div>

         <div label="Factory"> 
            <p>
                In order to make your tobacco product more effective, you will need to upgrade both the 
                chemicals and manufacturing factors of your product. Based on which tier scientist you hire, you 
                will be able to increase the concentration of chemicals and strengthen flavors in your company’s 
                product. You can also build new factories to increase production of your product.
            </p>
         </div>

         <div label="Tips"> 
            <p>- You can choose to pass on doing an action within a certain category, but you will need to 
                 decide when you should act or pass!</p>
            <p>- Make sure to keep some cash on hand in case you get sued.</p>
            <p>- Always read how your chemicals will affect not only your product but also the users!</p>
            <p>- Pay attention to the death count, since it will make lead to you making less money, losing more market share, etc.</p>
            <p>- If you want to learn some more about the tactics tobacco companies use, make sure to check out the "Learn More" section!</p>
         </div>
        </Tabs> 
      </div>
    );
}

function InstructionScreen() {
    return (
       <App></App>
    )
}

export default class smoke extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            instructions: false,
        }
    }

    showInstructions = () => {
        this.setState({instructions: true});
    };

    render() { 
        return (
            <div onClick={() => this.showInstructions()}>
                {this.state.instructions ? <InstructionScreen></InstructionScreen> : <WelcomeVideo></WelcomeVideo>}
            </div>
        );
    }
}